import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnvironmentService } from '@eforall/common';
import { NounIcon } from '@interfaces';
import { KENDO_TABSTRIP, SelectEvent } from '@progress/kendo-angular-layout';
import { ExplorerNotesPart } from '../../shared-parts';
import { PersonBasicInfoPart } from './basic-info/person-basic-info.part';
import { PersonEmailsSentPart } from './emails-sent/person-emails-sent.part';
import { PersonEngagementsPart } from './engagements/person-engagements.part';
import { PersonEntrepreneurshipPart } from './entrepreneurship/person-entrepreneurship.part';
import { PersonOverviewPart } from './overview/person-overview.part';
import { PersonExplorerService } from './person-explorer.service';
import { PersonVolunteeringPart } from './volunteering/person-volunteering.part';


type Tab = 'Overview' | 'BasicInfo' | 'Entrepreneurship' | 'Volunteering' | 'AutoEmail' | 'Notes' | 'Engagements' | 'Staff';

@Component({
	selector: 'person-explorer',
	imports: [
		KENDO_TABSTRIP,
		PersonOverviewPart,
		PersonBasicInfoPart,
		PersonEntrepreneurshipPart,
		PersonVolunteeringPart,
		PersonEmailsSentPart,
		ExplorerNotesPart,
		PersonEngagementsPart,
	],
	templateUrl: './person-explorer.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./person-explorer.part.scss'],
})
export class PersonExplorerPart {

	#env = inject(EnvironmentService);
	readonly personExplorerService = inject(PersonExplorerService);

	getTabInfo(tab: Tab) {

		const formatIconClass = (icon: string) => `fa-light ${icon}`;

		switch (tab) {
			case 'Overview': return { title: 'Overview', icon: formatIconClass('fa-grid-2') };
			case 'BasicInfo': return { title: 'Basic Info', icon: formatIconClass(NounIcon.Person) };
			case 'Entrepreneurship': return { title: 'Entrepreneurship', icon: formatIconClass(NounIcon.AccTeam) };
			case 'Volunteering': return { title: 'Volunteering', icon: formatIconClass(NounIcon.Volunteer) };
			case 'Notes': return { title: 'Notes', icon: formatIconClass(NounIcon.Notes) };
			case 'Engagements': return { title: 'Engagements', icon: formatIconClass(NounIcon.Engagement) };
			case 'AutoEmail': return { title: 'Auto Email', icon: formatIconClass(NounIcon.Email) };
			case 'Staff': return { title: 'Staff', icon: formatIconClass(NounIcon.Staff) };
			default: throw new Error(`Unsupported tab: ${tab satisfies never}`);
		}
	}

	onTabChange(event: SelectEvent) {
		this.personExplorerService.explorer.nav.setActiveTab(event.index);
	}
}
